import { Badge } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { WorkingTimeImportStatus } from "@/orval/gen"
import { getWorkingTimeImportStatusColor } from "./getWorkingTimeImportStatusColor"
import { WorkingTimeImportStatusIcon } from "./WorkingTimeImportStatusIcon"

export function WorkingTimeImportStatusBadge({
  status,
}: {
  status: WorkingTimeImportStatus
}) {
  const { t } = useTranslation("app_server")
  const color = getWorkingTimeImportStatusColor(status)
  return (
    <Badge
      leftSection={<WorkingTimeImportStatusIcon status={status} />}
      color={color}
    >
      {t(`WorkingTimeImportStatus_${status}`)}
    </Badge>
  )
}
